import { render, staticRenderFns } from "./distributionLevel.vue?vue&type=template&id=2a36edb1&scoped=true"
import script from "./distributionLevel.vue?vue&type=script&lang=js"
export * from "./distributionLevel.vue?vue&type=script&lang=js"
import style0 from "./distributionLevel.vue?vue&type=style&index=0&id=2a36edb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a36edb1",
  null
  
)

export default component.exports